import { getType, Instance, types } from 'mobx-state-tree'
import '../../ieConfig/MobxConfig'
import { Bank, BankType } from './Bank'
import { Card, CardType } from './Card'
import { UPI, UPIType } from './UPI'
import { Wallet, WalletType } from './Wallet'

const Address = types.model('Address', {
  addline1: types.optional(types.string, ''),
  addline2: types.optional(types.string, ''),
  zipcode: types.optional(types.string, ''),
  state: types.optional(types.string, ''),
  city: types.optional(types.string, ''),
})
const Status = types.model('Status', {
  isNewUser: types.optional(types.boolean, false),
  status: types.optional(types.string, ''),
})

const User = types
  .model('User', {
    id: types.optional(types.string, ''), // CustomerId
    mobileNumber: types.optional(types.number, 0),
    OTP: types.optional(types.number, 0),
    requestCustID: types.optional(types.string, ''),
    name: types.optional(types.string, ''),
    firstName: types.optional(types.string, ''),
    lastName: types.optional(types.string, ''),
    dob: types.optional(types.string, ''),
    externalId: types.optional(types.string, ''),
    subCustName: types.optional(types.string, ''),
    email: types.optional(types.string, ''),
    paymentMethod: types.array(types.union(Wallet, Card, UPI, Bank)),
    kycType: types.optional(types.string, ''),
    passwordmodifiedtime: types.optional(types.string, ''),
    consent: types.optional(types.string, ''),
    address: types.array(Address),
    status: types.optional(Status, {}),
    isNewUser: types.optional(types.boolean, false),
    refreshFoodCards: types.optional(types.integer, 0),
  })
  .actions((self) => ({
    updateSaveCards(card: CardType): void {
      const allSavedCards = self.paymentMethod.filter((item) => getType(item).name === 'Card') as [CardType]
      allSavedCards.map((element) => {
        if (element.id === card.id) {
          return {
            ...element,
            ...card,
          }
        } else {
          return element
        }
      })
    },
    updateCardBalance(token: string, balance: string): void {
      const cardIndex: any = self.paymentMethod.findIndex((item: any) => item?.token === token)
      const item: any = self.paymentMethod[cardIndex]
      item.cardBalance.balance = String(balance)
      item.cardBalance.isLoading = false
      item.cardBalance.error = ''
      self.refreshFoodCards = self.refreshFoodCards + 1
    },
    updateCardBalanceLoader(token: string, isLoading: boolean): void {
      const cardIndex: any = self.paymentMethod.findIndex((item: any) => item?.token === token)
      const item: any = self.paymentMethod[cardIndex]
      item.cardBalance.isLoading = isLoading
      item.cardBalance.error = ''
      item.cardBalance.balance = ''
      self.refreshFoodCards = self.refreshFoodCards + 1
    },
    updateCardBalanceError(token: string, error: string, balance: string = ''): void {
      const cardIndex: any = self.paymentMethod.findIndex((item: any) => item?.token === token)
      const item: any = self.paymentMethod[cardIndex]
      item.cardBalance.error = error
      item.cardBalance.isLoading = false
      item.cardBalance.balance = balance
      self.refreshFoodCards = self.refreshFoodCards + 1
    },
    updateStatus(isNewUser: boolean, status: string = '') {
      self.status.isNewUser = isNewUser
      self.status.status = status
    },
    addPaymentMethod(payInstrument: WalletType | CardType | UPIType | BankType): void {
      self.paymentMethod.push(payInstrument)
    },
    deleteCard(token: string, isSavedVpa: any = false) {
      const type = isSavedVpa ? 'instrumentId' : 'token'
      self.paymentMethod = self?.paymentMethod?.filter((item: any) => String(item[type]) !== String(token))
    },
    addSavedCards(cards: CardType[]) {
      if (self.paymentMethod.find((item) => getType(item).name === 'Card')) {
        const items = self.paymentMethod.filter((item) => getType(item).name !== 'Card')
        self.paymentMethod.replace(items)
        cards.map((item) => self.paymentMethod.push(Card.create(item)))
      } else {
        cards.map((item) => self.paymentMethod.push(Card.create(item)))
      }
    },
    addVPAList(vpaList: UPIType[]) {
      if (self.paymentMethod.find((item) => getType(item).name === 'UPI')) {
        const items = self.paymentMethod.filter((item) => getType(item).name !== 'UPI')
        self.paymentMethod.replace(items)
        vpaList.map((item) => self.paymentMethod.push(UPI.create(item)))
      } else {
        vpaList.map((item) => self.paymentMethod.push(UPI.create(item)))
      }
    },
    deleteSavedCards() {
      const items = self.paymentMethod.filter((item) => getType(item).name !== 'Card')
      self.paymentMethod.replace(items)
    },
    updateUserDetails(mobileNumber: number, name: string, id: string) {
      self.mobileNumber = mobileNumber
      self.name = name
      self.id = id
    },
    updateJioWalletValidateOtpResponse(wallet: WalletType) {
      const walletIndex = self.paymentMethod.findIndex((item) => getType(item).name === 'Wallet')
      self.paymentMethod[walletIndex] = {
        ...self.paymentMethod[walletIndex],
        balance: wallet.balance,
        walletUID: wallet.walletUID,
        trackerid: wallet.trackerid,
        instrId: wallet.instrId,
      } as WalletType
    },
    updateJioWallet(wallet: WalletType) {
      const walletIndex = self.paymentMethod.findIndex((item) => getType(item).name === 'Wallet')
      self.paymentMethod[walletIndex] = {
        ...self.paymentMethod[walletIndex],
        status: wallet.status,
        uuid: wallet.uuid,
      } as WalletType
    },
    updateNewUserJioWallet(wallet: WalletType) {
      const walletIndex = self.paymentMethod.findIndex((item) => getType(item).name === 'Wallet')
      self.paymentMethod[walletIndex] = {
        ...self.paymentMethod[walletIndex],
        mobile: wallet.mobile,
        uuid: wallet.uuid,
        ovdNumber: wallet.ovdNumber,
        ovdType: wallet.ovdType,
      } as WalletType
    },
    getWallet() {
      const [wallet] = self.paymentMethod.filter((item) => item.paymentType === 'Wallet') as [WalletType]
      return wallet
    },
    updateWallet(jioCardNumber: string): void {
      const walletndex = self.paymentMethod.findIndex((item) => getType(item).name === 'Wallet')
      const walletData = {
        ...self.paymentMethod[walletndex],
        jiocardnum: jioCardNumber,
      } as WalletType
      self.paymentMethod.remove(self.paymentMethod[walletndex])
      self.paymentMethod.push(Wallet.create(walletData))
    },
    updateUserData(parms: any) {
      self.id = parms?.customerid
      self.mobileNumber = Number(parms?.mobileNumber ?? 0)
      self.requestCustID = parms?.requestCustID
      self.name = parms?.customername

      const address = {
        addline1: parms?.addline1,
        addline2: parms?.addline2,
        zipcode: parms?.zipcode,
        state: parms?.state,
        city: parms?.city,
      }
      self.address.push(address)
    },
  }))

const UserInitialData = {
  name: 'User',
}

export type UserType = Instance<typeof User>
export { User, UserInitialData }
